import { render, staticRenderFns } from "./EducationLevelListComponent.vue?vue&type=template&id=74dea6d0"
import script from "./EducationLevelListComponent.vue?vue&type=script&lang=js"
export * from "./EducationLevelListComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports